{
  "nl": {
    "timetable": {
      "headline": "Organiseer je schooldag",
      "today": "Vandaag",
      "month": "Maand",
      "week": "Week",
      "day": "Dag",
      "weekNumberFormat": "(Week {weekNumber})",
      "dayFormat": "{day}, {date}",
      "previous": "Terug",
      "next": "Verder",
      "defaultCalendarTitle": "Mijn Lesrooster",
      "calendar": "Lesrooster",
      "createNewTimetable": "Nieuw lesrooster aanmaken",
      "settings": "Instellingen",
      "lastSynced": "Laatst gesynchroniseerd:",
      "breakTimeTooltip": "Tijdens schoolvrije periodes worden er geen lessen weergegeven.",
      "untisSyncedTooltip": "Agenda gesynchroniseerd vanuit Untis",
      "sync": {
        "chip": {
          "syncing": "Lesrooster wordt gesynchroniseerd"
        },
        "toast": {
          "initialSyncing": {
            "title": "Lesrooster wordt gesynchroniseerd",
            "body": "Het kan even duren voordat het lesrooster is geladen."
          },
          "success": "Lesrooster succesvol gesynchroniseerd",
          "errorAuthExpired": "Verbinding met WebUntis verlopen. Verbind je account opnieuw.",
          "errorNotConnected": "Geen WebUntis-account verbonden",
          "errorNotFound": "Schooljaar niet gevonden in WebUntis",
          "errorGeneric": "Lesrooster kan momenteel niet worden gesynchroniseerd"
        }
      },
      "offcanvas": {
        "title": "Instellingen",
        "untisHint": {
          "title": "WebUntis Lesrooster",
          "description": "Deze agenda wordt {highlightSync} met je WebUntis lesrooster.",
          "highlightSync": "automatisch gesynchroniseerd",
          "bullet1": "Bij WebUntis kun je {highlightBullet1}.",
          "highlightBullet1": "afspraken wijzigen of verplaatsen",
          "bullet2": "In het fobizz lesrooster kun je je {highlightBullet2}.",
          "highlightBullet2": "lessen plannen"
        },
        "webuntisTip": {
          "title": "Tip voor WebUntis-scholen",
          "linkText": "fobizz.com/untis-plattform"
        },
        "sections": {
          "basicSettings": {
            "title": "Basisinstellingen",
            "dateRangeLabel": "Periode",
            "dateRange": "Van {startDate} tot {endDate}",
            "calendarName": "Naam",
            "lessonDuration": "Duur van een lesuur",
            "lessonDurationOption": "{duration} min.",
            "deleteTimetable": "Lesrooster verwijderen",
            "validation": {
              "nameRequired": "Voer een naam in.",
              "durationRequired": "Selecteer een lesduur."
            }
          },
          "breakTimes": {
            "title": "Vakanties & schoolvrije periodes",
            "addButton": "Nieuwe vakantieperiode toevoegen",
            "editEntry": "Item bewerken",
            "deleteEntry": "Item verwijderen",
            "loading": "Vakantieperiodes laden...",
            "alertTitle": "Goed om te weten:",
            "alertDescription": "Tijdens vakantieperiodes worden er geen cursusafspraken in je lesrooster weergegeven."
          },
          "courses": {
            "title": "Mijn Cursussen",
            "addCourseButton": "Nieuwe cursus toevoegen",
            "editCourse": "Cursus bewerken",
            "deleteCourse": "Cursus verwijderen",
            "emptyState": {
              "headline": "Maak nu je eerste cursus aan",
              "description": "Met je cursussen kun je vervolgens je lesrooster vullen.",
              "addButton": "Cursus toevoegen"
            },
            "loading": "Cursussen laden..."
          }
        },
        "flash": {
          "updateSuccess": "Instellingen succesvol opgeslagen",
          "updateFailed": "Fout bij het opslaan van de instellingen"
        }
      },
      "colors": {
        "label": "Cursuskleur",
        "yellow": "Geel",
        "orange": "Oranje",
        "red": "Rood",
        "magenta": "Magenta",
        "green": "Groen",
        "teal": "Turkoois",
        "cyan": "Cyaan",
        "patrol": "Patrol",
        "purple": "Lila",
        "purpur": "Purper",
        "gray": "Grijs"
      },
      "errors": {
        "failedToLoadEvent": "Afspraak kon niet worden geladen",
        "failedToSaveEvent": "Afspraak kon niet worden opgeslagen"
      },
      "validation": {
        "titleMaxLength": "De titel mag maximaal {max} tekens lang zijn",
        "courseNameMaxLength": "De cursusnaam mag maximaal {max} tekens lang zijn"
      },
      "create": {
        "headline": "Nieuw lesrooster aanmaken",
        "form": {
          "titleLabel": "Titel",
          "namePlaceholder": "Titel invoeren...",
          "dateRangeLabel": "Start- en einddatum",
          "dateFromLabel": "Van",
          "dateToLabel": "Tot",
          "submitting": "Lesrooster wordt aangemaakt..."
        },
        "validation": {
          "titleRequired": "Voer een naam in",
          "startDateRequired": "Selecteer een startdatum",
          "invalidStartDate": "Voer een geldige startdatum in",
          "endDateRequired": "Selecteer een einddatum",
          "invalidEndDate": "Voer een geldige einddatum in",
          "endDateAfterStart": "Einddatum moet na de startdatum liggen of gelijk zijn"
        },
        "flash": {
          "created": "Lesrooster succesvol aangemaakt",
          "createFailed": "Fout bij het aanmaken van het lesrooster"
        }
      },
      "createEvent": {
        "title": "Nieuwe afspraak aanmaken",
        "courseLabel": "Afspraak aanmaken voor:",
        "courseSelection": {
          "placeholder": "Selecteren...",
          "newCourse": "Nieuwe cursus",
          "otherEvent": "Andere afspraak",
          "selectCourse": "Cursus selecteren",
          "loading": "Cursussen laden...",
          "courses": "Cursussen",
          "courseSectionLabel": "Lesuur in cursus",
          "otherEventSectionLabel": "Andere datum"
        },
        "dateAndRecurrence": "Weekdag en herhaling",
        "recurrenceLabel": "Herhaling",
        "recurrenceOptions": {
          "onetime": "Eenmalig",
          "weekly": "Wekelijks",
          "biweekly": "Tweewekelijks",
          "quadweekly": "Elke 4 weken"
        },
        "durationLabel": "Duur",
        "eventTitleLabel": "Titel van de afspraak",
        "eventTitlePlaceholder": "Voer titel in...",
        "courseNameLabel": "Cursustitel",
        "courseNamePlaceholder": "Bijv. Wiskunde 7B",
        "courseColorLabel": "Kies kleur",
        "errors": {
          "endTimeBeforeStart": "De eindtijd moet na de starttijd liggen",
          "createFailed": "Fout bij het aanmaken van de afspraak"
        }
      },
      "courseModal": {
        "courseNameLabel": "Cursusnaam",
        "courseNamePlaceholder": "Voer titel in...",
        "courseColorLabel": "Kleur",
        "classroomLabel": "Klaslokaal koppelen",
        "classroomPlaceholder": "Niet gekoppeld",
        "validation": {
          "courseNameRequired": "Voer een cursusnaam in"
        },
        "createCourse": {
          "title": "Nieuwe cursus aanmaken",
          "create": "Aanmaken",
          "errors": {
            "createFailed": "Fout bij het aanmaken van de cursus"
          }
        },
        "editCourse": {
          "title": "Cursus bewerken",
          "save": "Opslaan",
          "errors": {
            "editFailed": "Fout bij het bijwerken van de cursus"
          }
        }
      },
      "deleteCourse": {
        "title": "Cursus verwijderen?",
        "message": "Let op: Als je deze cursus verwijdert, worden alle bijbehorende afspraken geannuleerd (totaal {count}). Weet je zeker dat je de hele cursus wilt verwijderen?",
        "delete": "Ja, verwijderen",
        "errors": {
          "deleteFailed": "Fout bij het verwijderen van de cursus"
        }
      },
      "breakTimeModal": {
        "titleLabel": "Titel",
        "titlePlaceholder": "Zomervakantie, Herfstvakantie,...",
        "startDateLabel": "Van",
        "endDateLabel": "Tot",
        "validation": {
          "titleRequired": "Voer een titel in",
          "startDateRequired": "Kies een startdatum",
          "endDateRequired": "Kies een einddatum",
          "endDateMustBeAfterStartDate": "De einddatum moet na de startdatum liggen"
        },
        "createBreakTime": {
          "title": "Lesvrije periodes toevoegen",
          "success": "Lesvrije periode succesvol toegevoegd",
          "errors": {
            "createFailed": "Fout bij het toevoegen van de lesvrije periode"
          }
        },
        "editBreakTime": {
          "title": "Lesvrije periode bewerken",
          "success": "Lesvrije periode succesvol bijgewerkt",
          "errors": {
            "editFailed": "Fout bij het bijwerken van de lesvrije periode"
          }
        }
      },
      "deleteBreakTime": {
        "title": "Lesvrije periode verwijderen?",
        "message": "De invoer wordt uit je lesrooster verwijderd.",
        "delete": "Ja, verwijderen",
        "errors": {
          "deleteFailed": "Fout bij het verwijderen van de lesvrije periode"
        }
      },
      "deleteTimetable": {
        "title": "Lesrooster verwijderen?",
        "message": "Het lesrooster {calendarName} wordt inclusief alle invoeren verwijderd.",
        "delete": "Ja, verwijderen",
        "success": "Lesrooster succesvol verwijderd",
        "errors": {
          "deleteFailed": "Fout bij het verwijderen van het lesrooster"
        }
      },
      "lessonPlan": {
        "entryButton": "Lesontwerp 🤓",
        "tabsLabel": "Lesuur en lesontwerp",
        "lessonTab": "Lesuur",
        "planTab": "Lesontwerp",
        "minutes": "Min.",
        "bufferDuration": "ca. {minutes} min. · optioneel",
        "loadErrorTitle": "Lesontwerp kon niet worden geladen",
        "loadError": "Laad de pagina opnieuw of probeer het later nog eens.",
        "form": {
          "title": "Lesontwerp maken",
          "description": "Maak een gestructureerd lesontwerp op basis van de gegevens van dit uur.",
          "sourceContext": "Titel, notities & materialen",
          "instruction": "Waar moet nog rekening mee worden gehouden? (optioneel)",
          "instructionPlaceholder": "Bijv. groepswerk en een korte resultaatbespreking",
          "automatic": "Automatisch",
          "entryType": "Soort lesopening",
          "entryTypes": {
            "problem": "Probleemgericht",
            "informative": "Informatief",
            "associative": "Associatief",
            "playful": "Speels"
          },
          "lessonFocus": "Focus van het lesuur",
          "lessonFocuses": {
            "presentation": "Presentatie",
            "groupwork": "Groepswerk",
            "solo_work": "Individueel werk",
            "creativity": "Creativiteit"
          }
        },
        "generate": "Lesontwerp maken 🤓",
        "generating": "Lesontwerp wordt gemaakt…",
        "generationError": "Het lesontwerp kon niet worden gemaakt. Je kunt het opnieuw proberen.",
        "learningObjectives": "Leerdoelen",
        "curriculum": {
          "basedOn": "Gebaseerd op leerplannen voor {place}.",
          "basedOnWithoutPlace": "Gebaseerd op leerplannen.",
          "hide": "Verbergen",
          "noSubject": "We konden geen vak afleiden uit de cursusnaam. Noem de cursus naar het vak, bijvoorbeeld 'Wiskunde 7b', dan gebruikt de AI bij het volgende ontwerp een leerplan.",
          "notFound": "Voor deze les hebben we geen geschikt leerplan gevonden.",
          "show": "Weergeven",
          "unknownRegion": "Zonder deelstaat gebruikt de AI geen leerplan.",
          "upload": "Eigen uploaden"
        },
        "phases": "Lesverloop",
        "primaryActors": {
          "learners": "Leerlingen",
          "mixed": "Docent en leerlingen",
          "teacher": "Docent"
        },
        "description": "Beschrijving",
        "materials": "Materialen",
        "materialType": "Materiaalsoort",
        "selectMaterial": "Materiaal selecteren",
        "createMaterial": "Materiaal maken",
        "materialGenerating": "Materiaal wordt gemaakt…",
        "materialPending": "Materiaal wordt voorbereid…",
        "materialError": "Het materiaal kon niet worden gemaakt. Probeer het opnieuw.",
        "openMaterial": "Materiaal openen",
        "createProject": "Project maken",
        "projectGenerating": "Project wordt gemaakt…",
        "openProject": "Project openen",
        "projectError": "Het project kon niet worden gemaakt. Probeer het opnieuw.",
        "projectClassTypeOnetimeError": "In een 24-uurs klaslokaal kunnen geen verdere projecten worden gemaakt.",
        "inProject": "In het project",
        "projectModal": {
          "title": "Project voor \"{title}\" maken",
          "description": "Kies de fasen waaruit de taken ontstaan. Naam, beschrijving en hulpmiddelen worden hieruit afgeleid, reeds gemaakte materialen van de fasen worden gekoppeld.",
          "phases": "Fasen",
          "phasesHelp": "Fasen waarin voornamelijk de docent handelt, zijn niet vooraf geselecteerd.",
          "actor": {
            "teacher": "Docent",
            "learners": "Leerling",
            "mixed": "Gezamenlijk"
          },
          "noPhaseSelected": "Selecteer ten minste één fase.",
          "teacherOnlyPhases": "Selecteer ten minste één fase waarin leerlingen actief werken.",
          "help": "Optioneel: aanwijzingen voor de opdracht, de toon of de vrijgeschakelde hulpmiddelen."
        },
        "instructionsModal": {
          "material": {
            "title": "{material} voor „{phase}” aanmaken",
            "description": "Leerdoelen, doelgroep, fase-inhoud en actievorm worden automatisch doorgegeven.",
            "help": "Optioneel: omvang, moeilijkheidsgraad, opdrachtformaat of differentiatie."
          },
          "placeholder": "Verdere aanwijzingen toevoegen …"
        },
        "materialKinds": {
          "assistant": "AI-Assistent",
          "classroom_screen": "Klassenraamscherm",
          "pinboard": "Prikbord",
          "survey": "Enquête",
          "text_document": "Tekstdocument",
          "web_page": "Website",
          "word_cloud": "Woordwolk",
          "worksheet": "Werkblad"
        }
      },
      "eventDetails": {
        "headlineLesson": "Lesuur plannen",
        "headlineOther": "Afspraak plannen",
        "cardHeadlineOther": "Andere afspraak",
        "backLink": "Lesroosteroverzicht",
        "saved": "Wijzigingen opgeslagen",
        "form": {
          "titlePlaceholderLesson": "Onderwerp van het lesuur invoeren",
          "titlePlaceholderOther": "Titel invoeren",
          "titleLabel": "Titel",
          "notesLabel": "Notities",
          "notesPlaceholder": "Lesuur plannen",
          "notesPlaceholderOther": "Afspraak plannen",
          "materialsLabel": "Materialen",
          "projectsLabel": "Projecten",
          "attachProjectButton": "Project toevoegen",
          "searchMaterialsPlaceholder": "Mijn opslag doorzoeken...",
          "noResultsFound": "Geen resultaten gevonden",
          "dropzoneHint": "Sleep het hierheen of",
          "dropzoneSelectFile": "Bestand selecteren",
          "lessonTopicLabel": "Leerstof",
          "lessonTopicPlaceholder": "Hier kan de leerstof van dit lesuur met behulp van AI worden samengevat uit bovenstaande onderdelen.",
          "lessonTopicHint": "Je kunt met behulp van AI het lesuur samenvatten. Selecteer de inhoud die gebruikt moet worden.",
          "summarizeButton": "Lesuur samenvatten",
          "summarizeAgainButton": "Lesuur opnieuw samenvatten",
          "summarizingButton": "Wordt samengevat…",
          "syncToUntisButton": "Naar WebUntis overzetten",
          "summarizeError": "Fout bij het samenvatten van het lesuur",
          "syncSuccess": "Leerstof succesvol naar WebUntis overgezet",
          "syncError": "Overzetting naar WebUntis mislukt"
        },
        "materialsError": "Fout bij het opslaan van de materialen",
        "discontinueCourse": "Cursus beëindigen",
        "discontinueSeries": "Afspraakreeks beëindigen",
        "previousEvent": "Vorig lesuur",
        "nextEvent": "Volgend lesuur",
        "cancelledLabel": "Geannuleerd",
        "cancelledNoticeTitleLesson": "Deze les vervalt.",
        "cancelledNoticeTitleOther": "Deze afspraak vervalt.",
        "cancelledNoticeDescription": "Alle informatie blijft behouden en kan later opnieuw worden gebruikt."
      },
      "discontinueCourse": {
        "lesson": {
          "title": "Cursus beëindigen?",
          "message": "Als je de cursus beëindigt, worden deze afspraak en alle volgende afspraken van de cursus geannuleerd.",
          "description": "Weet je zeker dat je alle {count} volgende afspraken van deze cursus wilt annuleren?",
          "confirm": "Ja, beëindigen"
        },
        "other": {
          "title": "Afspraakreeks beëindigen?",
          "message": "Als je de afspraakreeks beëindigt, worden deze afspraak en alle volgende afspraken van de reeks geannuleerd.",
          "description": "Weet je zeker dat je alle {count} volgende afspraken van deze reeks wilt annuleren?",
          "confirm": "Ja, beëindigen"
        },
        "successMessage": "Cursus succesvol beëindigd",
        "errorMessage": "Fout bij het beëindigen van de cursus"
      },
      "cancelEvent": {
        "lesson": {
          "title": "Lesuur annuleren?",
          "message": "Dit lesuur wordt uit je agenda verwijderd.",
          "confirm": "Ja, annuleren",
          "buttonLabel": "Lesuur vervalt"
        },
        "other": {
          "title": "Afspraak annuleren?",
          "message": "Deze afspraak wordt uit je agenda verwijderd.",
          "confirm": "Ja, annuleren",
          "buttonLabel": "Afspraak vervalt"
        },
        "successMessage": "Afspraak succesvol geannuleerd",
        "errorMessage": "Fout bij het annuleren van de afspraak"
      },
      "restoreEvent": {
        "lesson": {
          "buttonLabel": "Les herstellen"
        },
        "other": {
          "buttonLabel": "Afspraak herstellen"
        },
        "successMessage": "De afspraak is hersteld",
        "errorMessage": "Fout bij het herstellen van de afspraak"
      },
      "linkClassroom": {
        "title": "Klassenraam koppelen aan deze cursus",
        "labelTooltip": "Koppel een digitale klassenraam voor deze leergroep aan deze cursus. Zo kun je eenvoudig projecten aanmaken en inhoud makkelijker delen met je leergroep.",
        "selectPlaceholder": "Selecteren",
        "confirm": "Koppelen",
        "cancel": "Annuleren",
        "success": "Klassenraam succesvol gekoppeld",
        "error": "Fout bij het koppelen van het klassenraam",
        "buttonLabel": "Klassenraam koppelen"
      },
      "attachProject": {
        "title": "Project aan lesuur toevoegen",
        "selectLabel": "Projecten uit {schoolClassName}",
        "selectPlaceholder": "Selecteren",
        "newProject": "Nieuw project",
        "confirm": "Toevoegen",
        "cancel": "Annuleren",
        "error": "Fout bij het toevoegen van het project"
      },
      "untisImportTeaser": {
        "text": "Gebruikt jouw school WebUntis? Dan kun je eenvoudig je lesrooster importeren. Informatie hierover vind je hier:"
      },
      "untisSyncWarning": {
        "title": "Let op",
        "body": "Alleen de „{highlight}” wordt naar WebUntis overgezet — alle andere inhoud blijft in fobizz.",
        "bodyHighlight": "Leerstofsamenvatting",
        "callout": "Bestaande inhoud in het veld „Leerstof” in WebUntis wordt hierbij overschreven.",
        "confirmButton": "Oké, begrepen",
        "cancelButton": "Annuleren",
        "dontShowAgain": "Melding niet meer tonen"
      },
      "trialModal": {
        "title": "Jouw cadeau: 30 dagen fobizz Pro",
        "intro": "Je hebt zojuist je Untis-lesrooster verbonden met fobizz — fijn dat je er bent!",
        "body": "Om fobizz goed uit te proberen, geven we je 30 dagen Pro: {highlight}.",
        "bodyHighlight": "AI-Chat, materiaal maken en alle trainingen",
        "cancellation": "Je hoeft niet op te zeggen — je proefperiode eindigt automatisch. Je lesrooster blijft behouden en synchroniseert verder met WebUntis.",
        "email": "De details sturen we je ook per e-mail.",
        "confirmButton": "Naar het lesrooster"
      }
    }
  }
}
